const activeFlags = [
    'view-files',
    'authentication-teams',
    'authentication-strong-password-requirement'
];

export default activeFlags;
